import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const SECTIONS = [
  {
    n: "1",
    t: "OBJETO",
    p: [
      "Flodelica Fiscal presta servicios profesionales relacionados con asesoría, consultoría, análisis, planeación, estrategia y acompañamiento en materia fiscal, contable, financiera y administrativa para personas físicas y morales.",
      "La contratación de cualquier servicio implica la aceptación expresa de estos Términos y Condiciones.",
    ],
  },
  {
    n: "2",
    t: "NATURALEZA DE LOS SERVICIOS",
    p: [
      "Todos los servicios ofrecidos por Flodelica Fiscal son de carácter profesional, especializado y personalizado.",
      "Cada estrategia, análisis, diagnóstico, recomendación o servicio se desarrolla conforme a la información proporcionada por el CLIENTE y está diseñado exclusivamente para su caso particular.",
      "Por tal motivo, los servicios no constituyen productos estandarizados ni pueden ser reutilizados, revendidos o asignados a otro cliente.",
    ],
  },
  {
    n: "3",
    t: "CONTRATACIÓN",
    p: ["La contratación podrá realizarse mediante:"],
    list: [
      "Sitio web.",
      "Correo electrónico.",
      "WhatsApp.",
      "Llamada telefónica.",
      "Videollamada.",
      "Firma electrónica.",
      "Firma autógrafa.",
      "Plataformas digitales.",
      "Cualquier otro medio autorizado por Flodelica Fiscal.",
    ],
    p2: ["La contratación quedará formalizada desde que ocurra cualquiera de los siguientes eventos:"],
    list2: [
      "Confirmación del pago.",
      "Aceptación de la propuesta comercial.",
      "Firma del contrato correspondiente.",
      "Confirmación escrita por cualquier medio electrónico.",
    ],
  },
  {
    n: "4",
    t: "INICIO DEL SERVICIO",
    p: [
      "El CLIENTE reconoce que el servicio profesional comienza inmediatamente después de la confirmación del pago.",
      "Se entenderá iniciado el servicio cuando ocurra cualquiera de las siguientes actividades:",
    ],
    list: [
      "Apertura del expediente.",
      "Asignación del caso al equipo profesional.",
      "Solicitud de documentación.",
      "Recepción de documentos.",
      "Revisión de información.",
      "Investigación técnica o normativa.",
      "Elaboración de estrategias.",
      "Programación de reuniones.",
      "Cualquier actividad administrativa o profesional relacionada con el servicio contratado.",
    ],
    p2: ["No será necesario que exista una reunión o entrega de resultados para considerar iniciado el servicio."],
  },
  {
    n: "5",
    t: "HONORARIOS",
    p: [
      "Los honorarios serán informados previamente al CLIENTE antes de iniciar cualquier servicio.",
      "Todos los precios podrán expresarse en pesos mexicanos (MXN), dólares estadounidenses (USD) o cualquier otra moneda indicada por Flodelica Fiscal.",
      "Los impuestos aplicables serán desglosados cuando corresponda conforme a la legislación vigente.",
    ],
  },
  {
    n: "6",
    t: "FORMAS DE PAGO",
    p: ["Aceptamos, entre otros:"],
    list: [
      "Tarjetas de crédito.",
      "Tarjetas de débito.",
      "Transferencias bancarias.",
      "SPEI.",
      "Plataformas de pago electrónico.",
      "Otros medios autorizados por Flodelica Fiscal.",
    ],
    p2: ["El CLIENTE declara que el medio de pago utilizado le pertenece o cuenta con autorización suficiente para utilizarlo."],
  },
  {
    n: "7",
    t: "POLÍTICA DE NO CANCELACIÓN Y NO REEMBOLSO",
    p: [
      "Debido a que todos los servicios prestados por Flodelica Fiscal son profesionales, personalizados y comienzan a ejecutarse desde el momento de la contratación, no existen cancelaciones ni devoluciones una vez iniciado el servicio.",
      "El CLIENTE reconoce que desde la confirmación del pago se asignan recursos humanos, tiempo profesional, herramientas tecnológicas y conocimientos especializados para atender su caso.",
      "En consecuencia:",
    ],
    list: [
      "No procederán cancelaciones una vez iniciado el proceso.",
      "No existirán devoluciones totales ni parciales.",
      "El abandono voluntario del proceso no dará derecho a reembolso.",
      "La falta de entrega de documentación por parte del CLIENTE no genera obligación de devolución.",
      "La inasistencia a reuniones o asesorías tampoco dará lugar a reembolsos.",
      "El cambio de opinión respecto del servicio contratado no constituye causa de cancelación.",
    ],
    p2: [
      "Los honorarios pagados remuneran el análisis, planeación, estrategia y tiempo profesional invertido desde el inicio del expediente, independientemente de que el CLIENTE decida concluir o no el proceso.",
    ],
  },
  {
    n: "8",
    t: "CONTRACARGOS Y DESCONOCIMIENTOS DE PAGO",
    p: [
      "El CLIENTE acepta que el pago realizado constituye una autorización expresa para la prestación del servicio contratado.",
      "En caso de que el CLIENTE inicie un procedimiento de contracargo, desconocimiento del cargo, reverso de pago o cualquier reclamación similar ante su institución financiera o procesador de pagos, Flodelica Fiscal podrá presentar toda la evidencia relacionada con la contratación y prestación del servicio, incluyendo, entre otros:",
    ],
    list: [
      "Contratos.",
      "Comprobantes de pago.",
      "Correos electrónicos.",
      "Conversaciones por WhatsApp.",
      "Formularios de contratación.",
      "Grabaciones telefónicas.",
      "Evidencia documental.",
      "Registros internos.",
      "Reportes de trabajo.",
      "Cualquier otra evidencia que demuestre la aceptación y ejecución del servicio.",
    ],
  },
  {
    n: "9",
    t: "OBLIGACIONES DEL CLIENTE",
    p: ["El CLIENTE se compromete a:"],
    list: [
      "Proporcionar información veraz, completa y actualizada.",
      "Entregar oportunamente la documentación requerida.",
      "Atender las solicitudes del equipo profesional.",
      "Colaborar durante el desarrollo del servicio.",
      "Abstenerse de proporcionar información falsa o incompleta.",
    ],
    p2: ["Flodelica Fiscal no será responsable por retrasos o afectaciones derivados de la omisión o entrega tardía de información por parte del CLIENTE."],
  },
  {
    n: "10",
    t: "LIMITACIÓN DE RESPONSABILIDAD",
    p: [
      "Los servicios prestados por Flodelica Fiscal constituyen asesoría profesional basada en la información proporcionada por el CLIENTE y en la legislación vigente al momento de su emisión.",
      "Flodelica Fiscal no garantiza resultados específicos ni será responsable por decisiones tomadas por el CLIENTE, cambios en la legislación, criterios de autoridades fiscales o información falsa, incompleta o incorrecta proporcionada por el propio CLIENTE.",
    ],
  },
  {
    n: "11",
    t: "PROPIEDAD INTELECTUAL",
    p: [
      "Todos los documentos, estrategias, análisis, diagnósticos, metodologías, formatos, informes, presentaciones y demás materiales elaborados por Flodelica Fiscal están protegidos por las leyes aplicables en materia de propiedad intelectual.",
      "Queda prohibida su reproducción, distribución, comercialización o utilización para fines distintos a los contratados sin autorización previa y por escrito de Flodelica Fiscal.",
    ],
  },
  {
    n: "12",
    t: "CONFIDENCIALIDAD",
    p: ["Toda la información proporcionada por el CLIENTE será tratada con carácter confidencial y utilizada exclusivamente para la prestación de los servicios contratados, salvo obligación legal en contrario."],
  },
  {
    n: "13",
    t: "MODIFICACIONES",
    p: [
      "Flodelica Fiscal podrá actualizar o modificar los presentes Términos y Condiciones en cualquier momento.",
      "Las modificaciones surtirán efectos desde su publicación en el sitio web.",
    ],
  },
  {
    n: "14",
    t: "LEGISLACIÓN APLICABLE Y JURISDICCIÓN",
    p: [
      "Los presentes Términos y Condiciones se regirán por las leyes de los Estados Unidos Mexicanos.",
      "Para la interpretación, cumplimiento o ejecución de los mismos, las partes se someten expresamente a la jurisdicción de los tribunales competentes del domicilio de Flodelica Fiscal, renunciando a cualquier otro fuero que pudiera corresponderles por razón de su domicilio presente o futuro.",
    ],
  },
  {
    n: "15",
    t: "ACEPTACIÓN",
    p: ["Al utilizar este sitio web, contratar cualquiera de nuestros servicios o realizar un pago por cualquier medio, el CLIENTE declara haber leído y aceptado íntegramente los presentes Términos y Condiciones, obligándose a su cumplimiento."],
  },
];

export const TermsModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-3xl bg-[#0A0A0B] border border-white/10 text-white p-0 gap-0 max-h-[85vh] flex flex-col"
        data-testid="terms-modal"
      >
        <DialogHeader className="px-6 md:px-10 pt-8 pb-5 border-b border-white/10">
          <span className="flo-label text-gold mb-3 block">Flodelica Fiscal</span>
          <DialogTitle className="font-serif-display text-2xl md:text-3xl tracking-tight text-white text-left">
            Términos y Condiciones de Uso y Contratación de Servicios
          </DialogTitle>
          <DialogDescription className="text-zinc-500 text-left text-xs mt-2">
            Última actualización: Julio de 2026
          </DialogDescription>
        </DialogHeader>

        <div className="flex-1 min-h-0 overflow-y-auto px-6 md:px-10 py-6" data-testid="terms-scroll">
          <div className="space-y-8">
            <div className="space-y-3">
              <p className="text-zinc-300 leading-relaxed">Bienvenido(a) a Flodelica Fiscal.</p>
              <p className="text-zinc-400 leading-relaxed text-sm">
                Los presentes Términos y Condiciones regulan el acceso, navegación y contratación de los servicios
                profesionales ofrecidos por Flodelica Fiscal (en adelante, "EL PRESTADOR") a través de su sitio web.
              </p>
              <p className="text-zinc-400 leading-relaxed text-sm">
                EL PRESTADOR tiene su domicilio en Calle 32 Ext. 269, Colonia Montes de Amé, Mérida, Yucatán, C.P. 97115,
                México.
              </p>
              <p className="text-zinc-400 leading-relaxed text-sm">
                Al acceder al sitio web, solicitar información, contratar cualquiera de nuestros servicios o realizar un
                pago por cualquier medio, el usuario (en adelante, "EL CLIENTE") declara haber leído, comprendido y
                aceptado íntegramente los presentes Términos y Condiciones.
              </p>
            </div>

            {SECTIONS.map((s) => (
              <div key={s.n} className="space-y-3" data-testid={`terms-section-${s.n}`}>
                <h3 className="font-serif-display text-lg md:text-xl text-white flex items-baseline gap-3">
                  <span className="text-gold text-sm">{s.n}.</span>
                  {s.t}
                </h3>
                {s.p?.map((para, i) => (
                  <p key={`p-${i}`} className="text-zinc-400 leading-relaxed text-sm">{para}</p>
                ))}
                {s.list && (
                  <ul className="space-y-1.5 pl-1">
                    {s.list.map((li, i) => (
                      <li key={`l-${i}`} className="text-zinc-400 text-sm flex gap-2">
                        <span className="text-gold mt-1.5 h-1 w-1 rounded-full bg-gold shrink-0" />
                        {li}
                      </li>
                    ))}
                  </ul>
                )}
                {s.p2?.map((para, i) => (
                  <p key={`p2-${i}`} className="text-zinc-400 leading-relaxed text-sm">{para}</p>
                ))}
                {s.list2 && (
                  <ul className="space-y-1.5 pl-1">
                    {s.list2.map((li, i) => (
                      <li key={`l2-${i}`} className="text-zinc-400 text-sm flex gap-2">
                        <span className="text-gold mt-1.5 h-1 w-1 rounded-full bg-gold shrink-0" />
                        {li}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
